import React from "react";
import Table from "../Table";
import Empty from "@assets/icons/emptyBookImage.svg";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";

import * as S from "../styles";

export default function TableStone({ data, lastUpdate, loading }) {
  return (
    <S.Card>
      <header>
        <div>
          <S.Title>Estoque STONE</S.Title>
          {lastUpdate && (
            <p>{`Atualizado em ${format(lastUpdate, "d 'de' MMM 'às' H:mm", {
              locale: ptBR,
            })}`}</p>
          )}
        </div>
        {data && (
          <S.RequestQDButton
            to={{ pathname: "http://bit.ly/formsangels22-2" }}
            target="_blank"
          >
            Solicitar QD
          </S.RequestQDButton>
        )}
      </header>

      {data || loading ? (
        <S.StoneContainer>
          <Table
            title="Baixo giro - Serial, USB e Serial-USB"
            data={data ? data["Baixo giro"] : null}
            loading={loading}
            isStone
          />
          <Table
            title="Alto giro - Smart POS e GPRS-WIFI"
            data={data ? data["Alto giro"] : null}
            loading={loading}
            isStone
          />
        </S.StoneContainer>
      ) : (
        <S.EmptyContainer>
          <img src={Empty} />
          <span>Nenhum dado encontrado</span>
        </S.EmptyContainer>
      )}
    </S.Card>
  );
}
